import type {InputProps, RefProp} from 'src/types/react';

import * as React from 'react';

import {classify} from 'src/utils/classify';

import ErrorList from 'src/components/lib/error-list';

import css from './error-input.css';


type Props = InputProps & {
  className?: string | null | undefined;
  errors?: string[] | undefined;
  hideErrorText?: boolean;
  inputRef?: RefProp<HTMLInputElement>;
  disabled?: unknown;
};

const ErrorInput = ({
  className,
  // @ts-expect-error - TS2322 - Type 'never[]' is not assignable to type 'never'.
  errors = [],
  hideErrorText,
  inputRef,
  // @ts-expect-error - TS2700 - Rest types may only be created from object types.
  ...props
}: Props): React.ReactElement<React.ComponentProps<'div'>> => (
  <div className={classify(css.container, className)}>
    <input
      // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
      className={errors.length ? css.errorInput : css.input}
      ref={inputRef}
      {...props}
    />
    {/* @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'. */}
    {errors.length > 0 && !hideErrorText && (
      <ErrorList className={css.errors} errors={errors} />
    )}
  </div>
);

export default ErrorInput;
